import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../../shared/makeApiCall";
import ServiceDetailsForm from "../../../components/forms/setup/services/ServiceDetailsForm";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";

import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function ServicesViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [services, setServices] = useState({
    data: [],
  });

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getServices = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `services?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setServices(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const createService = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall(
      "services/create",
      payload,
      "multipart/form-data"
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Service added",
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getServices("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const updateService = async function (values, index) {
    let callResult = await makePostApiCall(
      `services/${values.id}`,
      values,
      "multipart/form-data"
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Service updated",
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });

      setTimeout(function () {
        getServices("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const getServiceApiCall = async function (id) {
    let callResult = await makeGetApiCall(`services/${id}`);
    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const openAddServiceSlideOver = (isEdit, service, index) => {
    const serviceId = service ? service.id : null;
    const serviceName = service ? service.name : null;
    setSlideOver({
      childComponent: (
        <ServiceDetailsForm
          serviceId={serviceId}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateService(payload, index) : createService(payload)
          }
          title={isEdit ? `Update ${serviceName}` : "Add new service type"}
          getServiceApiCall={getServiceApiCall}
          addNewServiceOptionApiCall={addNewServiceOptionApiCall}
          updateServiceOptionApiCall={updateServiceOptionApiCall}
          removeServiceOptionApiCall={removeServiceOptionApiCall}
        />
      ),
      open: true,
    });
  };

  const deleteService = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteService/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = services.data.filter((item) => item.id !== id);
      setServices({ ...services, data: newItems });

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const askDeleteService = function (service, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteService(service.id, index)}
          message={`Are you sure you want to delete  ${service.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  const addNewServiceOptionApiCall = async function (serviceId, newOption) {
    let callResult = await makePostApiCall(`serviceOptions/create`, {
      service_id: serviceId,
      name: newOption,
    });
    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const updateServiceOptionApiCall = async function (option) {
    let callResult = await makePostApiCall(
      `serviceOptions/update/${option.id}`,
      {
        ...option,
      }
    );
    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const removeServiceOptionApiCall = async function (option) {
    let callResult = await makePostApiCall(
      `serviceOptions/delete/${option.id}`
    );
    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  return {
    openAddServiceSlideOver,
    getServices,
    loading,
    services,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteService,
    addNewServiceOptionApiCall,
  };
}
